import {AbsenceEn} from "./absence/en";
import {FlexibleHourEN} from "./flexible-hour/en";
import {GeneralSettingsEN} from "./general/en";
import {InoutEN} from "./inout/en";
import {MissionFeeEN} from "./mission-fee/en";
import {MissionVehicleEN} from "./mission-vehicle/en";
import {ResignEN} from "./resign/en";

export const ApplicationReasonEN = {
    "reason": {
        "sider": "Reason",
        "pageHeader": {
            "add": "Create a new reason",
            "update": "Create the reason"
        },
        "placeholder": {
            "name": "Name",
            "quota": "Time",
            "minimum": "",
            "unit": "",
            "inout": "",
            "paid": "",
            "state": "",
            "fine": "",
            "feeAmount": "",
            "earlyOut": "hh:mm",
            "lateIn": "hh:mm",
            "total": "hh:mm",
            "code": "Code",
            "order": "Order"
        },
        "option": {
            "yes": "Yes",
            "no": "No",
            "time_per_week": "Time/Week",
            "time_per_month": "Time/Month",
            "day_per_week": "Day/Week",
            "day_per_month": "Day/Month",
            "day_per_year": "Day/Year",
            "actived": "Active",
            "inactived": "Inactive"
        },
        "column": {
            "name": "Name",
            "quota": "Quota",
            "minimum": "Minimum",
            "unit": "Unit",
            "inout": "Check in/check out",
            "paid": "Paid",
            "state": "State",
            "fine": "Fine",
            "feeAmount": "Fee amount",
            "earlyOut": "Early out",
            "lateIn": "Late in",
            "total": "Total",
            "code": "Code",
            "order": "Order"

        },
    },
    ...AbsenceEn,
    ...FlexibleHourEN,
    ...GeneralSettingsEN,
    ...InoutEN,
    ...MissionFeeEN,
    ...MissionVehicleEN,
    ...ResignEN

}